module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "archiveContainer"
  }, [_c('header', [(_vm.pageName == 'posts') ? _c('div', [(_vm.projectName != 'all') ? _c('pageTemplateProjectHeader') : _vm._e(), _c('secondaryNav')]) : _vm._e(), (_vm.pageName != 'posts') ? _c('div', [(_vm.pageName == 'publications') ? _c('h2', {
    staticClass: "pageTitle"
  }, [_vm._v(_vm._s(_vm.renderText("刊行物", "PUBLICATIONS")))]) : _vm._e(), (_vm.pageName == 'news') ? _c('h2', {
    staticClass: "pageTitle"
  }, [_vm._v(_vm._s(_vm.renderText("報道記事", "NEWS")))]) : _vm._e()]) : _vm._e()]), (_vm.posts != null) ? _c('div', [(_vm.posts.length > 0) ? _c('div', [(_vm.pageName == 'posts') ? _c('div', {
    staticClass: "postLinks"
  }, _vm._l((_vm.posts), function(post) {
    return _c('postLink', {
      staticClass: "postLink",
      attrs: {
        "post": post
      }
    })
  })) : _vm._e(), (_vm.pageName == 'publications') ? _c('div', {
    staticClass: "publicationLinks"
  }, _vm._l((_vm.posts), function(post) {
    return _c('publicationLink', {
      staticClass: "publicationLink",
      attrs: {
        "post": post
      }
    })
  })) : _vm._e(), (_vm.pageName == 'news') ? _c('div', {
    staticClass: "newsLinks"
  }, _vm._l((_vm.posts), function(post) {
    return _c('newsLink', {
      staticClass: "newsLink",
      attrs: {
        "post": post
      }
    })
  })) : _vm._e()]) : _vm._e(), (_vm.posts.length == 0) ? _c('p', {
    staticClass: "notFound"
  }, [_vm._v("記事はありません")]) : _vm._e()]) : _vm._e(), (_vm.posts == null) ? _c('spinner') : _vm._e(), _c('footer', [_c('pagenation', {
    attrs: {
      "totalPages": _vm.totalPages
    }
  }), (_vm.pageName == 'posts' && _vm.projectName != 'all') ? _c('p', {
    staticClass: "back"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.toAbout
    }
  }, [_vm._v("← " + _vm._s(_vm.renderText('プロジェクトページへ戻る', 'BACK')))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e965b7a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archive/archiveTemplate.vue
// module id = 96
// module chunks = 1